import type { FC } from 'react';

import PressArticleCard from './press-article-card';

import styles from './_Press.module.scss';

import type { PressProps } from './types';

const Press: FC<PressProps> = ({ pressList }) => {
  return (
    <div className={styles.pressListSection}>
      {pressList.map(item => (
        <div className={styles.pressListSection__item} key={item.id}>
          <PressArticleCard
            id={item.id}
            image={item.image ?? '#'}
            title={item.title}
            description={item.description}
            date={item.date}
            digitalUrl={item.digitalUrl}
          />
        </div>
      ))}
    </div>
  );
};

export default Press;
